import { css } from "@linaria/core";

export const captionCls = css`
  --font-size: 14px;
  --line-height: 1.35;

  margin-top: 15px;

  box-sizing: border-box;
  width: 100%;
  min-height: 35px;

  display: block;
  text-align: center;

  font-family: figtree, helvetica, arial, sans-serif;
  font-size: var(--font-size);
  font-style: italic;
  line-height: var(--line-height);

  &:empty {
    display: none;
  }
`;

export const contentCls = css`
  position: relative;
  z-index: 3;
`;

export const titleCls = css`
  font-weight: 700;
  font-style: normal;
`;

export const spanCls = css`
  display: inline;
`;
